
import React, { Component } from 'react'
interface stateType{
}
interface propsType{
}
class Activity extends Component<propsType, stateType> {
    constructor(props: propsType) {
        super(props)
        this.state = {
            
        }

    }
    
    componentDidMount(){
    }
    render() {
        return (
            <div className="activity-con">
               activity
            </div>
        )
    }
}
export default Activity

